
































































































































import mixins from 'vue-typed-mixins';
import { CoverLetter, Cv, CvPublishTypeEnum } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';
import * as CvsStore from '@/containers/cvs/store';
import E2EMixin from '@/components/mixins/E2EMixin';

export default mixins(E2EMixin).extend({
  props: {
    cvs: {
      type: Array as () => Cv[],
      required: true,
    },
    coverLetters: {
      type: Array as () => CoverLetter[],
      required: true,
    },
  },
  data() {
    return {
      activeMenuIndex: null,
    };
  },
  methods: {
    getStatusBadgeClass(cv: Cv) {
      let klass = 'cvs-list-cv-status__badge';

      if (cv.publish_type === CvPublishTypeEnum.Open) klass += '--open';
      if (cv.publish_type === CvPublishTypeEnum.OpenUnlisted)
        klass += '--unlisted ';
      if (cv.publish_type === CvPublishTypeEnum.OpenWithPw) klass += '--pw ';
      if (cv.publish_type === CvPublishTypeEnum.Secret) klass += '--secret ';

      return klass;
    },
    async copyCv(cv: Cv) {
      const title = `${cv.title}のコピー`;
      const source_id = cv.id;
      await this.$store.dispatch(
        CvsStore.CreateCvFromCopy.namespaced({
          title,
          source_id,
        })
      );

      const latestCv = this.$store.getters['cvs/latestCv'];

      this.$notifySuccess(i18n.tc(i18nHints.common.notification.copied));
      // NOTE: go to profile edit page
      this.$router.push({
        name: this.$ua.isMobile
          ? 'cv_edit_path'
          : 'cv_section_profile_edit_path',
        params: { cv_id: latestCv.id },
      });
    },
    openMenu(index: number) {
      this.activeMenuIndex = this.activeMenuIndex === index ? null : index;
    },
    closeMenu() {
      this.activeMenuIndex = null;
    },
  },
});
